import React, { useContext, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SideBarLayout from '../../../global/layout/SideBarLayout';
import DetailsHeaderTabs from '../locationDetail/DetailsHeaderTabs';
import { getCompanyName, handleTabs, showToast } from '../../../utils';
import UsersAudit from '../userAndAudit/UsersAudit';
import AsignLocationToCollection from '../collections/AsignLocationToCollection';
import CreateCollections from '../collections/CreateCollections';
import { MyContext } from '../../../context';
import AsignLocationToPerScript from '../perScript/AsignLocationToPerScript';

const Sharing = () => {

    const { userData } = useContext(MyContext);

    const params = useParams();
    const { state } = useLocation();
    const locationId = params?.id || '';
    const locationData = state?.location;
    const vaultType = params?.type || '';

    const navigate = useNavigate();
    const [topTab, setTopTab] = useState<any>('sharing');
    const [showCreateCollection, setShowCreateCollection] = useState(false);
    const [asignLocCollection, setAsignLocCollection] = useState<any>(null);
    const [asignLocToScript, setAsignLocToScript] = useState<any>(null);

    return (
        <SideBarLayout>
            <div className="right-content-full-screen">
                <div className="ld-page ">

                    <div className="ld-header">
                        <div className="ld-header__left">
                            <h1 className="ld-header__title">{locationData?.name || ''}</h1>
                            <div className="ld-breadcrumb">
                                <button className="ld-breadcrumb__link" onClick={() => navigate(vaultType === 'myvault' ? '/location/myvault' : '/location/vault')}>
                                    {vaultType === 'myvault' ? "My Vault" : 'Location Vault'}
                                </button>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                                <span className="ld-breadcrumb__current">{locationData?.name || ''}</span>
                            </div>
                        </div>

                        <DetailsHeaderTabs
                            setTopTab={(type: any) => {
                                const route = handleTabs(type);
                                setTopTab(type)
                                if (route) {
                                    navigate(`${route}/${vaultType}/${locationId}`, {
                                        replace: true,
                                        state: { location: locationData },
                                    });
                                }
                            }}
                            topTab={topTab}
                        />

                        <div className="ld-header__actions">
                            <button
                                type='button'
                                onClick={() => {
                                    setAsignLocCollection({ location: locationData, id: locationId })
                                }}
                                className="ld-btn-assign"
                            >
                                Assign Location
                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    setAsignLocToScript({ location: locationData, id: locationId })
                                }}
                                className="ld-btn-assign"
                            >
                                Assign to script
                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    showToast('coming soon.', 'info')
                                }}
                                className="ld-btn-icon"
                                aria-label="Share"
                            >
                                <img src="/assets/images/upload-share-icon.svg" alt="Share" />
                            </button>
                        </div>
                    </div>
                    <UsersAudit
                        locationData={locationData}
                        locationId={locationId}
                        type='sharing'
                    />
                </div>

                {showCreateCollection &&
                    <CreateCollections
                        onClose={() => setShowCreateCollection(false)}
                        onDone={() => {
                            setShowCreateCollection(false)
                        }}
                    />
                }

                {asignLocCollection?.id &&
                    <AsignLocationToCollection
                        onClose={() => setAsignLocCollection(null)}
                        onCreate={() => {
                            setAsignLocCollection(null);
                            setShowCreateCollection(true)
                        }}
                        locationData={asignLocCollection}
                        production_company_name={getCompanyName(userData)}
                    />
                }

                {asignLocToScript?.id &&
                    <AsignLocationToPerScript
                        onClose={() => setAsignLocToScript(null)}
                        onCreate={() => {
                            setAsignLocToScript(null);
                        }}
                        locationData={asignLocToScript}
                        production_company_name={getCompanyName(userData)}
                    />
                }

            </div>

        </SideBarLayout>
    );
};

export default Sharing;